<template lang="pug">
div
  h1 Edit Issue

  LoaderOverlay(:loading="loading")
    IssueForm
</template>

<script>
  import { mapStores } from 'pinia'
  import { useIssueStore } from '@/stores/issue'

  import IssueForm from '../shared/form.vue'
  import LoaderOverlay from '@/components/shared/loader_overlay.vue'

  export default {
    components: {
      IssueForm,
      LoaderOverlay
    },

    props: {
      issueId: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        loading: true
      }
    },

    computed: {
      ...mapStores(useIssueStore)
    },

    async mounted() {
      const { issueId } = this

      await this.issueStore.$reset()
      await this.issueStore.fetch({ issueId })
      this.loading = false
    }
  }
</script>
